module.exports = "<div class=\"footer\">\n  &reg; Мој Термин\n</div>\n"